import { ReactComponent as CogIcon } from "@fortawesome/fontawesome-free/svgs/solid/cog.svg";
import SvgIcon, { type SvgIconProps } from "../SvgIcon";

const Cog = (props: SvgIconProps) => (
    <SvgIcon {...props} size={props.size || "fs"}>
        <CogIcon />
    </SvgIcon>
);

export default Cog;
